import axios from 'axios';
import { getAuth } from 'firebase/auth';

// Use REACT_APP_API_URL in staging/prod, default to /api in dev
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
});

// Interceptor to attach Firebase token to every request
api.interceptors.request.use(async (config) => {
  try {
    const auth = getAuth();
    const currentUser = auth.currentUser;

    if (currentUser) {
      const token = await currentUser.getIdToken();
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    config.headers['Content-Type'] = 'application/json';

  } catch (err) {
    console.warn('⚠️ Unable to attach auth token:', err.message);
  }

  return config;
}, (error) => Promise.reject(error));

export default api;